/* Thread N Cloud - in-page image zoom for size charts and linked images.
   Clicking a size chart opens it over the page instead of navigating to the image file.
   Tap/click the image to zoom in at that point, drag/scroll to move around, Esc or the close button to close. */
(function () {
  if (window.__tncZoom) return;
  window.__tncZoom = true;

  var IMG_RE = /\.(png|jpe?g|webp|gif|avif)(\?|$)/i;
  var css =
    '.tz{position:fixed;inset:0;z-index:9999;background:rgba(31,31,31,.94);display:flex;flex-direction:column;opacity:0;transition:opacity .2s ease}' +
    '.tz.is-open{opacity:1}' +
    '.tz__bar{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 16px;color:#F7F4EE;font:500 13px/1.3 Poppins,system-ui,sans-serif;flex:0 0 auto}' +
    '.tz__hint{opacity:.8}' +
    '.tz__btns{display:flex;gap:8px}' +
    '.tz__btn{width:42px;height:42px;border-radius:50%;border:1px solid rgba(247,244,238,.35);background:rgba(247,244,238,.08);color:#F7F4EE;font:400 22px/1 system-ui,sans-serif;cursor:pointer;display:grid;place-items:center}' +
    '.tz__btn:hover,.tz__btn:focus-visible{background:rgba(247,244,238,.2);outline:none}' +
    '.tz__stage{flex:1 1 auto;overflow:auto;-webkit-overflow-scrolling:touch;display:flex;cursor:zoom-in;touch-action:pan-x pan-y pinch-zoom}' +
    '.tz__stage.is-zoomed{cursor:grab}' +
    '.tz__stage.is-drag{cursor:grabbing}' +
    '.tz__img{margin:auto;display:block;max-width:calc(100vw - 24px);max-height:calc(100vh - 90px);width:auto;height:auto;border-radius:12px;box-shadow:0 20px 60px rgba(0,0,0,.35);user-select:none;-webkit-user-drag:none}' +
    '.tz__stage.is-zoomed .tz__img{max-width:none;max-height:none;margin:12px}' +
    'html.tz-lock,html.tz-lock body{overflow:hidden}';

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var overlay, stage, img, zoomBtn, lastFocus, scale = 1;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'tz';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image viewer');
    overlay.innerHTML =
      '<div class="tz__bar"><span class="tz__hint">Tap the chart to zoom &middot; drag to move</span>' +
      '<div class="tz__btns"><button type="button" class="tz__btn" data-tz-zoom aria-label="Zoom in">+</button>' +
      '<button type="button" class="tz__btn" data-tz-close aria-label="Close">&times;</button></div></div>' +
      '<div class="tz__stage"><img class="tz__img" alt=""></div>';
    document.body.appendChild(overlay);
    stage = overlay.querySelector('.tz__stage');
    img = overlay.querySelector('.tz__img');
    zoomBtn = overlay.querySelector('[data-tz-zoom]');

    overlay.querySelector('[data-tz-close]').addEventListener('click', close);
    zoomBtn.addEventListener('click', function () { setZoom(scale > 1 ? 1 : 2.2); });
    stage.addEventListener('click', function (e) {
      if (moved) return;
      if (e.target !== img) { if (scale === 1) close(); return; }
      setZoom(scale > 1 ? 1 : 2.2, e);
    });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === '+' || e.key === '=') setZoom(2.2);
      if (e.key === '-') setZoom(1);
    });

    // drag to pan when zoomed (mouse); touch uses native scrolling
    var down = false, sx, sy, sl, st, moved = false;
    stage.addEventListener('mousedown', function (e) {
      if (scale === 1) return;
      down = true; moved = false; sx = e.clientX; sy = e.clientY; sl = stage.scrollLeft; st = stage.scrollTop;
      stage.classList.add('is-drag'); e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) + Math.abs(dy) > 4) moved = true;
      stage.scrollLeft = sl - dx; stage.scrollTop = st - dy;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false; stage.classList.remove('is-drag');
      setTimeout(function () { moved = false; }, 0);
    });
  }

  function setZoom(next, evt) {
    var fitW = img.getBoundingClientRect().width;
    var rx = 0.5, ry = 0.5;
    if (evt && scale === 1) {
      var r = img.getBoundingClientRect();
      rx = (evt.clientX - r.left) / r.width; ry = (evt.clientY - r.top) / r.height;
    }
    if (next > 1) {
      var target = Math.min(fitW * next, Math.max(img.naturalWidth, fitW * 1.5));
      img.style.width = Math.round(target) + 'px';
      stage.classList.add('is-zoomed');
      zoomBtn.innerHTML = '&minus;'; zoomBtn.setAttribute('aria-label', 'Zoom out');
      requestAnimationFrame(function () {
        stage.scrollLeft = img.offsetWidth * rx - stage.clientWidth / 2 + 12;
        stage.scrollTop = img.offsetHeight * ry - stage.clientHeight / 2 + 12;
      });
    } else {
      img.style.width = '';
      stage.classList.remove('is-zoomed');
      zoomBtn.textContent = '+'; zoomBtn.setAttribute('aria-label', 'Zoom in');
      stage.scrollLeft = 0; stage.scrollTop = 0;
    }
    scale = next;
  }

  function open(src, alt) {
    if (!overlay) build();
    lastFocus = document.activeElement;
    setZoom(1);
    img.src = src;
    img.alt = alt || '';
    overlay.style.display = 'flex';
    document.documentElement.classList.add('tz-lock');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    overlay.querySelector('[data-tz-close]').focus();
  }

  function close() {
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('tz-lock');
    setTimeout(function () { overlay.style.display = 'none'; img.removeAttribute('src'); }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var isChart = a.classList.contains('size-chart') || a.hasAttribute('data-zoom');
    var isRteImage = a.querySelector('img') && IMG_RE.test(href) && a.closest('.rte, .pg-lead, .page-content, main');
    if (!isChart && !isRteImage) return;
    e.preventDefault();
    var inner = a.querySelector('img');
    open(a.href, inner ? inner.alt : '');
  });
})();
